import React from 'react';
import { getHexToRgb, typographyButton, typographyGroupLabel, visuallyHidden } from 'lib/core';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { LOADER_SIZE } from '../constants';

export const StyledProgressIndicator = styled.span`
  ${({ theme }) => typographyButton(theme)}
  align-items:center;
  color: inherit;
  display: flex;
  justify-content: flex-end;
  line-height: 1;
  ${({ hideProgress }) => hideProgress && visuallyHidden}
  ${({ isInline, labelMaxWidth, loaderSize, theme }) =>
    css`
      ${typographyGroupLabel(theme)};
      align-items: ${!isInline && 'flex-start'};
      color: ${({ theme }) => `rgba(${getHexToRgb(theme.color.additional.dark.value)}, 0.7)`};
      font-size: ${loaderSize === LOADER_SIZE.SMALL ? theme.font.size.body1.value : theme.font.size.default.value};
      max-width: ${isInline ? '194px' : labelMaxWidth};
      margin-left: ${({ isInline, theme }) => !isInline && theme.size.spacing.medium.value};
      margin-right: ${({ isInline, theme }) => !isInline && theme.size.spacing.medium.value};
      overflow-wrap: break-word;
      word-wrap: 'break-word';
    `};
`;

export const ProgressIndicator = ({
  className,
  dataTestId = '',
  hideProgress = false,
  isInline = false,
  label = 'loading...',
  labelMaxWidth = '500px',
  loaderSize = LOADER_SIZE.LARGE,
  progressLabel = '0',
  ...other
}) => {
  return progressLabel ? (
    <StyledProgressIndicator
      data-testid={dataTestId ? `${dataTestId}-progress-indicator-label` : undefined}
      {...{ className, hideProgress, isInline, label, labelMaxWidth, loaderSize }}
      {...other}
    >
      {Math.round(progressLabel)}%
    </StyledProgressIndicator>
  ) : null;
};

ProgressIndicator.propTypes = {
  /** Adds additional class name to the label for styling */
  className: PropTypes.string,
  /** Id value used for testing */
  dataTestId: PropTypes.string,
  /** If true, label will set a max-width before text will wrap on the word. */
  isInline: PropTypes.bool,
  /** Visually hides loader text */
  hideProgress: PropTypes.bool,
  /** The label text  */
  label: PropTypes.string,
  /** Adds label text  */
  progressLabel: PropTypes.node.isRequired,
  /** Determines the max-width of the label  */
  labelMaxWidth: PropTypes.string,
  /** Sets the size of the loader to small or large */
  loaderSize: PropTypes.oneOf(Object.values(LOADER_SIZE)),
};
